import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import RejectForm from './RejectForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
  initialValues: {
    reason: 'rejected',
    ...otherProps.initialValues,
  },
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(RejectForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Reject/RejectForm.container.js